import { render, staticRenderFns } from "./normal.vue?vue&type=template&id=23c2ae21&scoped=true&"
import script from "./normal.vue?vue&type=script&lang=ts&"
export * from "./normal.vue?vue&type=script&lang=ts&"
import style0 from "./normal.vue?vue&type=style&index=0&id=23c2ae21&lang=scss&scoped=true&"
import style1 from "./normal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c2ae21",
  null
  
)

export default component.exports